import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import GiphyEmojiButtons from '../../../../shared/_TBComponents/GiphyEmojiButtons';
import useFeed from '../hooks/useFeed';

const FeedGiphyEmoji = ({
  setFieldValue,
  values,
  feedPostId,
  commentId,
  fieldName,
}) => {
  const { handleUploadMediaUrl } = useFeed();

  const handleSelectGif = useCallback((gifUrl) => {
    if (feedPostId || commentId) {
      const activeMediaBarOb = {};
      if (feedPostId) {
        activeMediaBarOb[feedPostId] = true;
      }
      if (commentId) {
        activeMediaBarOb[commentId] = true;
      }
      handleUploadMediaUrl({ mediaUrl: gifUrl }, activeMediaBarOb);
    } else {
      handleUploadMediaUrl({ mediaUrl: gifUrl });
    }
  }, [feedPostId, commentId, handleUploadMediaUrl]);

  const handleSelectEmoji = useCallback((emoji) => {
    const currentValue = (values && values[fieldName]) || '';
    const newString = currentValue + emoji.native;
    setFieldValue(fieldName, newString);
  }, [values, fieldName, setFieldValue]);

  return (
    <GiphyEmojiButtons
      onSelectGif={handleSelectGif}
      onSelectEmoji={handleSelectEmoji}
    />
  );
};

FeedGiphyEmoji.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.instanceOf(Object).isRequired,
  feedPostId: PropTypes.number,
  commentId: PropTypes.number,
  fieldName: PropTypes.string.isRequired,
};

FeedGiphyEmoji.defaultProps = {
  feedPostId: null,
  commentId: null,
};

export default FeedGiphyEmoji;
